import * as Dialog from "@radix-ui/react-dialog";
import React, { useContext } from "react";
import Config from "src/config";
import { AuthContext } from "src/contexts/AuthContext";
import { ThemeContext } from "src/contexts/ThemeContext";
import { ArrowDownIcon } from "../../assets/Icon/ArrowDown/ArrownDown";
import { ArrowUpIcon } from "../../assets/Icon/ArrowUp/ArrowUp";
import { ReturnButton } from "./ReturnButton";
import {
  ContaGloboLogo,
  Container,
  EmailSpan,
  OpenUserMenu,
  UserButton,
  UserMenu
} from "./styles";

const redirectToHome = () => {
  const serviceID = localStorage.getItem("serviceId") || "";
  const redirectUrl =
    localStorage.getItem("callbackUrl") || Config.DEFAULT_REDIRECT_URL;

  const url = new URL(serviceID, Config.FE_BASE_URL);
  url.searchParams.append("url", redirectUrl);

  window.location.href = url.toString();
};

export function Header() {
  const { user, logout } = useContext(AuthContext);
  const { headerReturn, headerUser } = useContext(ThemeContext);

  return (
    <Container>
      {headerReturn && <ReturnButton onBackClick={redirectToHome} />}
      <ContaGloboLogo variant="conta" />
      {headerUser && user && (
        <Dialog.Root>
          <UserMenu>
            <UserButton>
              <EmailSpan>{user.email}</EmailSpan>
              <ArrowDownIcon />
              <ArrowUpIcon />
            </UserButton>
            <Dialog.Overlay />
            <Dialog.Content asChild>
              <OpenUserMenu>
                <span>{user.name}</span>
                <button onClick={logout}>Sair da Conta Globo</button>
              </OpenUserMenu>
            </Dialog.Content>
          </UserMenu>
        </Dialog.Root>
      )}
    </Container>
  );
}

export default Header;
